/**
 * @description Gestion des tableaux bootstrap
 */

(() => {
	// VARS
	const tables = document.querySelectorAll('table');

	// Functions
	const table = () => {
		tables.forEach((tab) => {
			tab.classList.add('table', 'table-bordered');
			tab.hasAttribute('cellpadding')
				? tab.removeAttribute('cellpadding')
				: '';
			tab.hasAttribute('cellspacing')
				? tab.removeAttribute('cellspacing')
				: '';
			const wrapper = document.createElement('div');
			wrapper.classList.add('table-responsive');
			tab.parentNode.insertBefore(wrapper, tab);
			wrapper.appendChild(tab);
		});
	};

	// INIT
	if (document.body.contains(document.querySelector('table'))) {
		table();
	}
})();
